import React from "react";

export const Footer = () => {
  return <footer className="footer">&#169; 2020 Chie Shiraishi</footer>;
};
